<template>
  <div class="page-table scrollable only-y mainDiv mb-30">
    <div class="card-base baslikBg animated fadeInUp">Yapı Ruhsat Listesi
      <div class="tanimlamaButon">
        <el-tooltip :content='$t("src.views.apps.genel.yeniKaydet")' :open-delay="500" placement="top"
                    v-if="yetkiTuru != '3'">
          <el-button v-on:click="goRoute('Yapı Ruhsat Tanımla')" size="mini" type="text"
                     icon="el-icon-plus"></el-button>
        </el-tooltip>
        <el-tooltip :content='$t("src.views.apps.genel.refresh")' :open-delay="500" placement="top">
          <el-button v-on:click="refreshPage()" style="margin-left: 15px !important" type="text"
                     icon="el-icon-refresh"></el-button>
        </el-tooltip>
      </div>
    </div>
    <div class="page-header card-base card-shadow--medium animated fadeInUp" v-loading="cariLoading || searchLoading"
         :element-loading-text='cariLoading ? "Yapı Ruhsat Listesi Getiriliyor. Lütfen Bekleyiniz." : "Yapı Ruhsat Aranıyor. Lütfen Bekleyiniz."'
         element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
      <el-row class="mt-0 mb-10">
        <el-col :lg="12" :md="12" :sm="24" :xs="24">
          <div>
            <el-radio-group size="small" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                            text-color="gray" :disabled="searchLoading">
              <el-radio-button label="1">
                <i class="mdi mdi-account mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                <transition name="slide-fade">
                  <label v-if="arsaDurumu === '1'">Aktif Ruhsatlar</label>
                </transition>
              </el-radio-button>
              <el-radio-button label="3">
                <i class="mdi mdi-account mdi-18px" style="color: orange; margin-right: 5px"></i>
                <transition name="slide-fade">
                  <label v-if="arsaDurumu === '3'">Eksik Ruhsat Evrakları</label>
                </transition>
              </el-radio-button>
              <el-radio-button label="0">
                <i class="mdi mdi-account mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                <transition name="slide-fade">
                  <label v-if="arsaDurumu === '0'">Pasif Ruhsatlar</label>
                </transition>
              </el-radio-button>
            </el-radio-group>
          </div>
        </el-col>
        <el-col :lg="12" :md="12" :sm="24" :xs="24" v-if="yetkiTuru != '3'">
          <el-col :lg="24" :md="24" :sm="24" :xs="24">
            <ul class="islemler">
              <li>
                <i class="mdi mdi-information" style="color: #f7ba2a"></i>
                <span>Yapı Ruhsat Evrakları</span>
              </li>
              <li v-if="arsaDurumu == '1'">
                <i class="mdi mdi-stop mdi-18px" style="color: #ec205f"></i>
                <span>Pasif yap</span>
              </li>
              <li v-else>
                <i class="mdi mdi-play mdi-18px" style="color: #048484"></i>
                <span>Aktif Yap</span>
              </li>
              <li>
                <i class="mdi mdi-trash-can mdi-18px" style="color: #ec205f"></i>
                <span>Yapı Ruhsatı Sil</span>
              </li>
            </ul>
          </el-col>
        </el-col>
      </el-row>
      <el-table v-loading="searchLoading" border stripe :data="arsaListe" style="width: 100%;"
                :element-loading-text='"Yapı Ruhsat Aranıyor. Lütfen bekleyin."'
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 1)">
        <el-table-column>
          <template slot="header" slot-scope="props">
            <el-input clearable v-on:clear="ruhsatAra" placeholder='Yatırımcı Ara' v-model="musteriAdi"
                      v-debounce:500ms="ruhsatAra" size="mini"></el-input>
          </template>
          <el-table-column prop="musteriAdi" label="Yatırımcı Adı" width="auto" :min-width="150">
            <template slot-scope="props">
              <div class="new-line-text">
                {{ props.row.musteriAdi }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column>
          <template slot="header" slot-scope="props">
            <el-input clearable v-on:clear="ruhsatAra" placeholder='Proje Ara' v-model="projeAdi"
                      v-debounce:500ms="ruhsatAra" size="mini"></el-input>
          </template>
          <el-table-column prop="projeAdi" label="Proje Adı" width="auto" :min-width="150">
            <template slot-scope="props">
              <div class="new-line-text">
                {{ props.row.projeAdi }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column>
          <el-table-column prop="adres" label="Adres" width="auto"/>
        </el-table-column>
        <el-table-column>
          <el-table-column prop="telefon" label="Telefon" width="auto"/>
        </el-table-column>
        <el-table-column>
          <el-table-column prop="eposta" label="E-Posta" width="auto"/>
        </el-table-column>
        <el-table-column v-if="yetkiTuru != '3'">
          <el-table-column :label='$t("src.views.apps.genel.islem")' align="right" width="200">
            <template slot-scope="scope">
              <el-tooltip content='Ruhsat Evrakları' :open-delay="500" placement="bottom">
                <el-button @click="updatePage(scope.row)" type="text" class="islem-button"
                           style="color: #186F65; margin-left: 0 !important;"
                           icon="mdi mdi-information-variant mdi-24px"></el-button>
              </el-tooltip>
              <el-tooltip content='Pasif Yap' :open-delay="500" v-if="arsaDurumu == '1'" placement="bottom">
                <el-button @click="changeArsaDurum(scope.row, '0')" class="buttonDel"
                           style="margin-left: 15px !important;" type="text"
                           icon="mdi mdi-stop mdi-24px"></el-button>
              </el-tooltip>
              <el-tooltip :content='$t("src.views.apps.yatirimci.liste.table.setActive")' :open-delay="500"
                          v-if="arsaDurumu == '0'" placement="bottom">
                <el-button @click="changeArsaDurum(scope.row, '1')" type="text"
                           style="margin-left: 15px !important;" class="islem-button-play islem-button ml-15"
                           icon="mdi mdi-play mdi-24px"></el-button>
              </el-tooltip>
              <el-tooltip content='Yapı Ruhsatı Tamamen Sil !' :open-delay="500"
                          placement="bottom">
                <el-button @click="arsaSil(scope.row)" class="buttonDel"
                           style="margin-left: 15px !important;" type="text"
                           icon="mdi mdi-trash-can mdi-24px"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-pagination background layout="sizes,prev, pager, next, jumper, total" :total="total"
                     @size-change="handleSizeChange" @current-change="pageChange" :page-sizes="[20, 50, 100]"
                     :current-page.sync="page" :next-click.sync="page" :prev-click.sync="page" @next-click="pageChange"
                     @prev-click="pageChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import EventBus from '@/components/event-bus'
import notification from '../../../notification'
import functions from '../../../functions'
import ruhsatService from "@/WSProvider/RuhsatService";

export default {
  name: "YapiRuhsatListesi",
  data() {
    return {
      loading: false,
      stateLoading: false,
      searchLoading: false,
      cariLoading: false,
      //editDialogLoading: false,
      editDialog: false,
      editDialogData: {},
      musteriList: [],
      arsaListe: [],
      radio: '1',
      radio1: "1",
      cariForm: {
        musteriAdi: "",
        eposta: "",
        firmaAdi: "",
        unvan: "",
        telefon: ""
      },
      rulesMusteri: {},
      sizes: 20,
      arsaDurumu: '1',
      page: 0,
      postPage: 0,
      total: 4,
      musteriAdi: "",
      projeAdi: "",
      yetkiTuru: "",
      unvanAra: "",
      adresAra: "",
      telefonAra: "",
      epostaAra: "",
      gelenCari: "",
      gidenCari: ""
    }
  },
  mounted() {
    this.yetkiTuru = this.$store.getters.getYetkiTuru
    this.getRuhsatList();
  },
  created() {
    // EventBus.$on("arsaListesi", () => {
    //   this.refreshPage()
    // });
  },
  methods: {
    getRuhsatList() {
      try {
        this.cariLoading = true;
        ruhsatService.ruhsatListele(this.arsaDurumu, this.postPage, this.sizes).then((response) => {
          if (response.status == 200) {
            localStorage.setItem("userDataDemirag", response.token);
            this.arsaListe = response.data.arsaList
            this.total = parseInt(response.data.toplamKayit)
          }
          this.cariLoading = false;
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else if (error.status == 404) {
              this.arsaListe = [];
            } else notification.Status("errorMsg", this, error.errMsg)
          }
          this.cariLoading = false;
        })
      } catch (e) {
        this.cariLoading = false;
      }
    },
    updatePage(data) {
      this.$store.commit('setYapiUpdateData', data)
      functions.routeSayfa("Yapı Ruhsat Tanımla", this)
    },
    ruhsatAra() {
      this.postPage = 0;
      this.page = 1
      if (this.musteriAdi.length > 0 || this.projeAdi.length > 0) {
        try {
          this.searchLoading = true;
          ruhsatService.ruhsatArama(this.musteriAdi, this.projeAdi, this.arsaDurumu, this.postPage, this.sizes).then(response => {
            if (response.status == 200) {
              this.arsaListe = response.data;
              this.total = parseInt(response.toplamKayit)
            }
            localStorage.setItem("userDataDemirag", response.token);
            this.searchLoading = false;
          }).catch(err => {
            if (err.responseJSON) {
              let error = err.responseJSON
              if (error.status == 401) {
                notification.Status(150, this);
              } else if (error.status == 404) {
                this.arsaListe = []
              }
            } else {
              //notification.Status(503, this)
            }
            this.searchLoading = false;
          })
        } catch (e) {
          // notification.Status("danger", this, "An error occurred during the customer search process.")
          this.searchLoading = false
        }
      } else {
        this.getRuhsatList();
      }
    },
    refreshPage() {
      this.page = 1;
      this.postPage = 0;
      this.loading = false;
      this.stateLoading = false;
      this.musteriAdi = '';
      this.projeAdi = '';
      this.getRuhsatList();
    },
    vazgec(formName) {
      this.$refs[formName].resetFields();
      this.editDialog = false;
      this.loading = false;
      this.stateLoading = false;
    },
    changeArsaDurum(selection, durum) {
      this.$confirm("Yapı Ruhsat durumunu güncellemek istediğinizden emin misiniz?", this.$t("src.views.apps.genel.uyari"), {
        confirmButtonText: this.$t("src.views.apps.genel.yes"),
        cancelButtonText: this.$t("src.views.apps.genel.no"),
        type: 'warning'
      }).then(() => {
        try {
          this.stateLoading = true;
          ruhsatService.ruhsatDurumDegis(selection.id, durum).then(response => {
            if (response.status == 200) {
              this.getRuhsatList();
            }
            this.stateLoading = false;
            notification.Status("success", this, response.msg);
            localStorage.setItem("userDataDemirag", response.token);
          }).catch(err => {
            if (err.responseJSON) {
              let error = err.responseJSON
              if (error.status == 401) {
                notification.Status(150, this);
              } else notification.Status("errorMsg", this, error.errMsg)
            } else {
              //notification.Status(503, this)
            }
            this.stateLoading = false;
          })
        } catch (e) {
          // notification.Status("success", this, "An error occurred while fetching the customer number.");
          this.stateLoading = false;
        }
      })
    },
    arsaSil(selection) {
      this.$confirm("Yapı Ruhsatı Tamamen Silmek istediğinizden emin misiniz?", this.$t("src.views.apps.genel.uyari"), {
        confirmButtonText: this.$t("src.views.apps.genel.yes"),
        cancelButtonText: this.$t("src.views.apps.genel.no"),
        type: 'warning'
      }).then(() => {
        try {
          this.stateLoading = true;
          ruhsatService.ruhsatTamamenSil(selection.id).then(response => {
            if (response.status == 200) {
              this.getRuhsatList();
            }
            this.stateLoading = false;
            notification.Status("success", this, response.msg);
            localStorage.setItem("userDataDemirag", response.token);
          }).catch(err => {
            if (err.responseJSON) {
              let error = err.responseJSON
              if (error.status == 401) {
                notification.Status(150, this);
              } else notification.Status("errorMsg", this, error.errMsg)
            } else {
              //notification.Status(503, this)
            }
            this.stateLoading = false;
          })
        } catch (e) {
          // notification.Status("success", this, "An error occurred while fetching the customer number.");
          this.stateLoading = false;
        }
      })
    },
    goRoute(name, scope) {
      if (scope) {
        this.$store.commit('changeCariUpdateData', scope);
      }
      functions.routeSayfa(name, this);
    },
    indexMethod(index) {
      return ((this.page - 1) * 10) + index + 1;
    },
    handleSizeChange(val) {
      this.sizes = val;
      this.getRuhsatList();
      //this.getMusteriListesi();
      // this.getMusteriProjeListesi();
    },
    handleChange(event) {
      this.arsaDurumu = event;
      this.page = 1;
      this.postPage = 0;
      //this.getMusteriListesi();
      this.getRuhsatList();
      // this.getMusteriProjeListesi();
      document.querySelector('.scrollable').scrollTo({top: 0, behavior: 'smooth'});
      this.firmaAdiAra = ""
      this.unvanAra = ""
      this.adresAra = ""
      this.telefonAra = ""
      this.epostaAra = ""
    },
    pageChange(val) {
      this.postPage = (val - 1) * this.sizes;
      this.getRuhsatList();
    },
  }
}

</script>

<style lang="scss">
.el-table .info-row {
  background: rgba(125, 199, 225, 0.45);
}

.el-table .error-row {
  background: rgba(249, 0, 26, 0.08);
}

.el-table .success-row {
  background: rgba(3, 249, 0, 0.08);
}

.el-table .warning-row {
  background: rgba(245, 249, 0, 0.08);
}
</style>
<style lang="scss" scoped>
.refresh {
  color: #fff;
  float: right;
  padding: 0 !important;
  transition: all 0.5s;

}

.refresh:hover {
  transform: rotate(360deg);
}

.el-pagination {
  margin-top: 20px;
  float: right;
}

.el-radio-button--mini .el-radio-button__inner label {
  position: relative;
  bottom: 5px;
}

.kaldirilmis {
  background: #ec205f;
  color: white;
  font-weight: bold;
  font-size: 16px;
  padding: 10px
}
</style>
<style lang="scss">
.slide-fade-enter-active {
  transition: all .3s ease;
}


@media (min-width: 768px) {
  .el-radio-button--mini .el-radio-button__inner {
    padding: 0 10px !important;
    font-size: 11px;
    border-radius: 0;
  }
}


.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to

  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}
</style>
<style>
.el-badge__content {
  background-color: red !important;
  color: white;
  width: 20px;
  height: 20px;
  padding: 0;
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 14px;
  font-weight: 450;
  margin-bottom: -20px !important;
}

.cari .el-badge__content.is-fixed {
  position: absolute;
  top: 0;
  right: 10px;
  -webkit-transform: translateY(-50%) translateX(100%);
  transform: translateY(-50%) translateX(-500%);
}

.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #FFFFFF;
  text-align: left;
  /* padding-left: 0; */
  /*background-color: #90c4a1;*/
  background-color: #3b94bd;
  border-color: #3b94bd;
  -webkit-box-shadow: -1px 0 0 0 #3b94bd;
  box-shadow: -1px 0 0 0 #3b94bd;
}
</style>
